module.exports = __webpack_public_path__ + "img/cursor_left.3d64c316.png";